import { MdbRippleModule } from 'mdb-angular-ui-kit/ripple';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component,  Input } from '@angular/core';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, NgSelectModule, MdbRippleModule],
  selector: 'mapfre-link',
  templateUrl: './mapfre-link.component.html'
})
export class MapfreLinkComponent{
  @Input() additionalClasses:                 string;
  @Input() icon:                              boolean;
  @Input() iconClasses:                       string;
  @Input() target:                            string;
  @Input() url:                               string;


}
